import { filter, map } from 'rxjs/operators';
import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import { Observable } from 'rxjs';
import { BrandingState } from '../../branding/store/branding.state';
import { BrandingService } from '../../branding/providers/branding.service';
import { AccessibilityService } from '../../../providers/accessibility/accessibility.service';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-data-security',
    templateUrl: './data-security.component.html',
    styleUrls: ['./data-security.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AsyncPipe, TranslatePipe]
})
export class DataSecurityComponent implements OnInit {
    public brandingData$: Observable<BrandingState>;
    public bodyText$: Observable<string>;

    constructor(private brandingService: BrandingService,
                private accessibilityService: AccessibilityService,
                private translate: TranslateService) {
        this.brandingData$ =
            this.brandingService.getBrandingSettingsFromStore().pipe(filter(e => e !== null && e !== undefined));
        
        this.bodyText$ = this.brandingData$.pipe(
            map(brandingData => this.getBodyText(brandingData))
        );
    }

    ngOnInit(): void {
        // BFSG: Announce legal document loading to screen readers
        this.translate.get('ACCESSIBILITY.SR_DATA_SECURITY_LOADED').subscribe(message => {
            this.accessibilityService.announceToScreenReader(message, 'polite');
        });
    }

    getBodyText(brandingData: BrandingState): string {
        const dataSecurity = brandingData?.translationKeys?.legal?.dataSecurity;
        return dataSecurity?.body ?? 'LEGAL.DATA-SECURITY-AGREEMENT.BODY';
    }
}
